export const menuDetailFeatureTranslationEN = {
  menuDetailFeature: {
    Component: {
      csv_output: 'csv output',
      delete: 'delete',
      close: 'close',
      setting: 'setting',
      search: 'search',
      reload: 'reload',
      detail: 'detail',
      save: 'save',
      change_btn: 'change btn',
    },
    Text: {
      menu_detail_normal: 'menu detail normal',
      all: 'all',
      japanese: 'japanese',
      english: 'english',
      simplified_chinese: 'simplified chinese',
      traditional_chinese: 'traditional chinese',
      korean: 'korean',
      vietnamese: 'vietnamese',
      display_name: 'display_name',
      remarks: 'notes',
      menu_settings: 'menu setting',
      notice_text:
        '※モバイルオーダーの表示名、説明は、 <br />　日本語以外の言語を選択し、その言語が未設定の場合、 <br />　英語が表示されます。 <br />',
      register_information: '〇レジ情報',
      menu_name: 'menu name',
      menu_type: ' menu type',
      display_timing: 'display timing',
      menu_property: 'menu property',
      menu_image: 'image',
      explanation: 'explanation',
      note1: 'note1',
      note2: 'note2',
      not_obtained: '未取得',
      control_condition: 'Control Condition',
      no_control: 'No Control',
      display_timing_group_radio: 'Display Timing Group',
      display_control_group_radio: 'Display Control Group',
      display_timing_group_select: 'Select Group:',
      display_timing_group_link: 'Manage in Display Timing Settings',
      group_not_selected: 'No group selected',
      no_timing_group_available: 'No display timing groups created yet. Please create one in the settings screen.',
      conditions_not_set: 'No conditions set',
      conditions_title: ' Conditions',
      conditions_weekday: 'Weekday',
      conditions_schedule: 'Schedule',
      conditions_schedule_none: 'Not specified',
      conditions_time: 'Time',
      conditions_time_none: 'Not specified',
      conditions_grace: 'Grace',
      conditions_grace_min: 'min',
      conditions_note: '※ Weekday/Schedule/Time are defined in Display Timing Settings. Changes apply to all related menus (reference type).',
      overlay_option_label: 'Hidden Display Option',
      overlay_option_subtitle: 'Behavior outside conditions - per menu setting',
      overlay_show: 'Show',
      overlay_show_desc: 'Show with overlay outside conditions, indicate orders not available',
      overlay_uncheck_note: '※ If unchecked, menu is hidden outside conditions',
      overlay_comment_label: 'Display Comment',
      overlay_comment_subtitle: 'Only when "Show" is selected',
      overlay_default_message: 'Orders not available during this time',
      overlay_default_note: '※ Default when empty: "Orders not available during this time"',
      display_control_group: 'Display Control Group:',
      note3: '※Only selectable when control mode is Display Control Group<br />※Multiple groups can be selected, active only when all groups are ordered.',
      display_control_group_radio_label: 'Display Control Group',
    },
    Table: {
      date_of_expired: 'date of expired',
      start: 'start',
      end: 'end',
      pos_cd: 'pos code',
      pos_name: 'pos name',
      amount_of_money_excluding_tax: 'amount of money excluding tax',
      amount_of_money_including_tax: 'amount of money<br />（including tax） <br />※レジデータ取 <br />込から取得',
    },
  },
};
